import config from '../../config';

/*
  RoleAdmin = 1
  RoleSubAdmin = 2
  RoleClient = 3
  RoleClientAccMgr = 4
  RoleUser = 5
*/

const menu = {
  client: { id: 1, text: 'Clients', url: '/clients' },
  admin: { id: 15, text: 'Admin', url: '/admin-panel', hidden: true },
  users: { id: 2, text: 'Users', url: '/users' },
  Campaigns: { id: 3, text: 'Campaigns', url: '/campaign' },
  Videos: { id: 4, text: 'Videos', url: '/videos' },
  Splash: { id: 5, text: 'Splash', url: '/splash' },
  Insights: { id: 6, text: 'Insights', url: '/insights' },
  Media: { id: 7, text: 'Videos', url: '/media/legacy' }, // @TODO remove once new submissions page is consolidated
  Plugins: { id: 8, text: 'Plugins', url: '/v2/plugins' },
  Submissions: { id: 9, text: 'Media', url: '/media' },
  Publishing: { id: 15, text: 'Publishing', url: '/publishing' },
  HelpCenter: { id: 13, text: 'Help Center', url: config.helpCenterLink, icon: 'HelpCircle' },
  Settings: { id: 14, text: 'Settings', url: '/settings', icon: 'Settings' },
  Compilation: { id: 16, text: 'Compilations', url: '/compilation' }
};

/**
 * Get menu by role and feature toggle
 */
export default (role, isUserClient, isSso, vcpEnabled) => {
  const menuOptions =
    role === 1
      ? [menu.client]
      : [menu.Campaigns, menu.Submissions, vcpEnabled ? menu.Publishing : menu.Plugins];

  const settings = getSettingsDropDown(isUserClient, isSso);

  const items = {
    main: menuOptions,
    settings,
    menuIcons: [menu.HelpCenter, menu.Settings]
  };

  const links = Object.values(items).reduce((acc, curr) => acc.concat(curr), []);
  // links.push(menu.Compilation);

  // if (role === 1) links.push(menu.admin);
  if (role !== 1) links.push(menu.Plugins, menu.Compilation);

  const access = links.map((op) => op?.url);

  return {
    ...items,
    access
  };
};

export const getSettingsDropDown = (isUserClient, isSso) => {
  return isUserClient
    ? [
        { id: 10, text: 'Billing', url: '/billing' },
        {
          id: 11,
          text: 'Users',
          url: '/organization',
          isFeature: true,
          feature: 'organization_menu_link'
        },
        isSso ? null : { id: 12, text: 'Change Password', url: '/change/password' },
        { id: 13, text: 'Sign Out' }
      ]
    : [
        { id: 12, text: 'Change Password', url: '/change/password' },
        { id: 13, text: 'Sign Out' }
      ];
};
export const getMenuIcons = () => {
  return [
    { id: 13, text: 'Help Center', url: config.helpCenterLink, icon: 'HelpCircle' },
    { id: 14, text: 'Settings', url: '/settings', icon: 'Settings' }
  ];
};



// WEBPACK FOOTER //
// ./src/redux/data/menu.js